import React from "react";

import Result from "./Result";
import classes from "./Results.module.css";

import { connect } from "react-redux";
import Spinner from "../UI/Spinner";
import { getMoreData, search } from "../../Actions/index";
import { formatPublishedDate } from "../../utility";

import Aux from "../../hoc/Aux";

class Results extends React.Component {
  state = { showDetails: "0px", color: "#606060" };
  toggleFilter = () => {
    if (this.state.showDetails === "0px")
      this.setState({ showDetails: "100%", color: "#0a0a0a" });
    else this.setState({ showDetails: "0px", color: "#606060" });
  };
  fillItUp = () => {
    this.props.getMoreData(
      this.props.results.nextPageToken,
      sessionStorage.getItem("query") || ""
    );
  };
  getMoreDataChecker = () => {
    const elem = document.querySelector("html");
    if (
      elem.scrollHeight - elem.scrollTop === elem.clientHeight &&
      this.props.pageNum > 0 &&
      this.props.pageNum < 5 &&
      !this.props.moreError &&
      !this.props.moreLoading
    )
      this.fillItUp();
  };
  componentWillMount = () => {
    if (!sessionStorage.getItem("query")) {
      this.props.history.push("/");
      return null;
    }
    window.addEventListener("scroll", this.getMoreDataChecker);
  };
  componentDidMount() {
    if (!this.props.results.items) {
      this.props.search(sessionStorage.getItem("query"));
    }
  }
  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.getMoreDataChecker);
  };
  renderControls() {
    const markup = (
      <Aux>
        <div
          onClick={this.toggleFilter}
          className={classes.ToggleBtn}
          style={{ color: this.state.color }}
        >
          <i className="fas fa-sliders-h" /> <span>FILTER</span>
        </div>
        <div className={classes.Details}>
          <div style={{ height: this.state.showDetails }}>
            <div>
              <h4>UPLOAD DATE</h4>
              <ul>
                <li>Last hour</li>
                <li>Today</li>
                <li>This week</li>
                <li>This month</li>
                <li>This year</li>
              </ul>
            </div>
            <div>
              <h4>TYPE</h4>
              <ul>
                <li>Video</li>
                <li>Channel</li>
                <li>Playlist</li>
                <li>Movie</li>
                <li>Show</li>
              </ul>
            </div>
            <div>
              <h4>DURATION</h4>
              <ul>
                <li>Short (&lt; 4 minutes)</li>
                <li>Long (&gt; 20 minutes)</li>
              </ul>
            </div>
            <div>
              <h4>FEATURES</h4>
              <ul>
                <li>Live</li>
                <li>4K</li>
                <li>HD</li>
                <li>Subtitles/CC</li>
                <li>Creative Commons</li>
                <li>360 &deg;</li>
                <li>VR180</li>
                <li>3D</li>
                <li>HDR</li>
                <li>Location</li>
                <li>Purchased</li>
              </ul>
            </div>
            <div>
              <h4>SORT BY</h4>
              <ul>
                <li className={classes.ActiveFilter}>Relevance</li>
                <li>Upload date</li>
                <li>View count</li>
                <li>Rating</li>
              </ul>
            </div>
          </div>
          <hr />
        </div>
      </Aux>
    );

    return markup;
  }
  render() {
    let markup, more;
    if (!this.props.results.items) markup = null;
    if (this.props.loading) {
      const style = {
        position: "absolute",
        top: "40%",
        left: "45%"
      };
      markup = <Spinner style={style} />;
    } else if (
      this.props.results &&
      this.props.results.items &&
      this.props.results.items.length > 0
    ) {
      markup = this.props.results.items.map((res, i) => {
        let datePublished = formatPublishedDate(res.snippet.publishedAt);

        if (res.statistics === undefined) res.statistics = { viewCount: 0 };
        if (res.contentDetails === undefined)
          res.contentDetails = { duration: "00:00" };

        return (
          <Result
            title={res.snippet.title}
            imgSrc={res.snippet.thumbnails.medium.url}
            channelName={res.snippet.channelTitle}
            channelId={res.snippet.channelId}
            datePublished={datePublished}
            description={res.snippet.description}
            key={res.id.videoId}
            videoId={res.id.videoId}
            index={i}
          />
        );
      });
    } else if (this.props.error) {
      const error = this.props.results.error;
      markup = (
        <div className={classes.Error}>
          <h2>Error: {error.error}</h2>
          <h3>Sorry!</h3>
          <p>{error.message.substr(0, 75)}. Please try again later.</p>
          <code>
            Error Code: <span className={classes.Code}>{error.code}</span>
          </code>
        </div>
      );
    }

    if (this.props.moreLoading)
      more = (
        <Spinner
          style={{
            display: "block",
            margin: "25px auto"
          }}
        />
      );
    else if (this.props.moreError) {
      const error = this.props.moreError;
      more = (
        <div className={classes.Error}>
          <h2>Error: {error.error}</h2>
          <p>{error.message}</p>
        </div>
      );
    }
    return (
      <div className={classes.Results}>
        {this.renderControls()}
        {markup}
        {more}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    results: state.searchResults.results,
    loading: state.searchResults.loading,
    moreError: state.searchResults.moreError,
    moreLoading: state.searchResults.moreLoading,
    pageNum: state.searchResults.pageNum
  };
};
export default connect(
  mapStateToProps,
  {
    getMoreData,
    search
  }
)(Results);
